module.exports = __webpack_public_path__ + "img/error_bg.b8b56ee.jpg";